// import axiosInstance from '../../utils/axiosConfig'; 
import axios from "axios";
export const GET_GARANTIE_CLAIM = "GET_GARANTIE_CLAIM";
export const GET_GARANTIE_CLAIM_FAILURE = "GET_GARANTIE_CLAIM_FAILURE";
export const FETCH_PI_GARANTIE_DATA_REQUEST = "FETCH_PI_GARANTIE_DATA_REQUEST";
export const fetchPiGarantiesData = (numContrat, dateSinistre) => async (dispatch) => {
  dispatch({ type: FETCH_PI_GARANTIE_DATA_REQUEST });

  try {
    // Step 1: Fetch token
    const tokenResponse = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL_STAR_PARTENAIRE_API_URL}/token`,
      {},
      {
        params: { grant_type: "authorization_code" },
        auth: {
          username: "DIGITAL_USER",
          password: "$g5AK3aNf&",
        },
      }
    );

    const token = tokenResponse.data.accessToken; 

    // Step 2: Fetch garanties
    const garantiesResponse = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL_STAR_PARTENAIRE_API_URL}/starpartenaire/api/consultation/garanties`,
      {
        params: {
          numContrat,
          dateSinistre, // format: "dd/MM/yyyy"
        },
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
      }
    );

    dispatch({
      type: GET_GARANTIE_CLAIM,
      payload: garantiesResponse.data,
    });

    return garantiesResponse.data;
  } catch (error) {
    console.error("Error fetching PI claim data:", error);
    dispatch({
      type: GET_GARANTIE_CLAIM_FAILURE,
      payload: error.response ? error.response.data : "Erreur serveur",
    });
  }
};
